import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { LinkShareController } from "../LinkShareController";
import { PasswordController } from "../PasswordController";
import styles from "../styles.module.css";

interface Props {
  saveSpa: (value: TValueForService<"ai_agents_spa">) => void;
  isDisabled: boolean;
}

export const SpaLinkPublish = ({ saveSpa, isDisabled }: Props) => {
  return (
    <div className={styles["publish-block"]}>
      <LinkShareController saveSpa={saveSpa} />
      <PasswordController saveSpa={saveSpa} isDisabled={isDisabled} />
    </div>
  );
};
